import {
  IsString,
  IsNotEmpty,
  IsArray,
  IsOptional,
  IsBoolean,
} from 'class-validator';

import type { UnitType } from '@vk-hr-tek/core/units';

import type { CompanyProfilesSource } from '../../types';

const NOT_EMPTY_OPTIONS = {
  message: 'Обязательное поле',
};

export class UpdateCompanyProfilesSettingsDto {
  @IsString(NOT_EMPTY_OPTIONS)
  @IsNotEmpty(NOT_EMPTY_OPTIONS)
  secureProfiles: 'true' | 'false';

  @IsString(NOT_EMPTY_OPTIONS)
  @IsOptional()
  representativesRelations?: 'true' | 'false';

  @IsString(NOT_EMPTY_OPTIONS)
  @IsOptional()
  accessProfilesSource?: CompanyProfilesSource;

  @IsString(NOT_EMPTY_OPTIONS)
  @IsOptional()
  unitType?: UnitType;

  @IsString({ each: true })
  @IsArray()
  @IsOptional()
  unitIds?: string[];

  @IsBoolean()
  @IsOptional()
  separateUnitsEnabled?: boolean;

  @IsString(NOT_EMPTY_OPTIONS)
  @IsOptional()
  vacationScheduleProfiles?: 'true' | 'false';
}
